import { Navigate } from 'react-router-dom';

/**
 * F5-T1a — la segunda pantalla de config muere. /admin/system-config
 * puentea al grupo Metas de Admin 08. El override individual sigue en Team.
 */
export function SystemConfigPage(): JSX.Element {
  return <Navigate to="/admin/settings?group=metas" replace />;
}
